import { render, staticRenderFns } from "./AcousticSettings.vue?vue&type=template&id=43cdebc4&"
import script from "./AcousticSettings.vue?vue&type=script&lang=js&"
export * from "./AcousticSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports